import {AfterViewChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CustomerRegistrationService} from '../../services/customer-registration/customer-registration.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {saveAs} from 'file-saver';
import AppConstants, {
  CustomerRegistrationType as CRT
} from '../../shared/common-components/AppConstants';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';

@Component({
    selector: 'app-customer-approval-list',
    templateUrl: './customer-approval-list.component.html',
    styleUrls: ['./customer-approval-list.component.css'],
    standalone: false
})
export class CustomerApprovalListComponent implements OnInit, AfterViewChecked {

  currentUser: any;
  status: any = null;
  isSysAdmin = false;
  rowHeight: any = 40;
  customers: any = [];
  rejectedCustomers: any = null;
  /*statusList = [CRS.CONFIRMED, CRS.CONFIRM_PENDING, CRS.REJECTED];*/
  columnAPI: any;
  gridAPI: any;
  statusList = [
    {id: 'Accepted', value: 'Accepted'},
    {id: 'Rejected', value: 'Approval Rejected'},
    {id: 'Confirm Pending', value: 'Waiting for Confirmation from User'},
    {id: 'Confirmed', value: 'Confirmed by User and Waiting for Approval'}
  ];
  registrationTypesAll = [CRT.USER, CRT.REPORTING_OFFICIAL];
  registrationTypesUser = [CRT.USER];
  registrationTypes = [];
  customerApprovalForm: UntypedFormGroup;
  custApprColumnDefs = [
    {headerName: 'Update Date', field: 'updateDate', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Customer Code', field: 'agencyCode', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Customer Name', field: 'agencyName', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Bureau Code', field: 'bureauCode', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Bureau Name', field: 'agencyBureauName', filter: 'agTextColumnFilter', sortable: true},
    {
      headerName: 'Location',
      valueGetter: function (params) {
        return ((params.data.city === null || '') ? '' : params.data.city) + (params.data.city ? ',' : '') +
          ((params.data.stateName === null || '') ? '' : params.data.stateName) + (params.data.stateName ? ',' : '') +
          ((params.data.countryName === null || '') ? '' : params.data.countryName);
      }, filter: 'agTextColumnFilter', sortable: true
    },
    {headerName: 'Access Requested', field: 'accessRequested', filter: 'agTextColumnFilter', sortable: true},
    {
      headerValueGetter: (params) => {
        const registrationType = this.customerApprovalForm ? this.customerApprovalForm.get('registrationType') ? this.customerApprovalForm.get('registrationType').value : '' : '';
        if (registrationType === 'User') {
          return 'Agency User';
        }
        return 'Agency Authorized Official';
      },
      cellRenderer: params => {
        if (params.data.registrationStatus !== 'Confirm Pending') {
          return '<a tabindex="0">' +
            params.data.lastName + ',' + params.data.firstName +
            '</a>';
        } else {
          return params.data.lastName + (params.data.lastName ? ',' : '') + params.data.firstName;
        }
      },
      onCellClicked: event => (event.data.registrationStatus !== 'Confirm Pending') ? this.onReportingOfficialClicked(event.data) : null
      , filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Phone Number',
      field: 'phone',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Status',
      field: 'registrationStatus',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Rejected Reason',
      colId: 'RejReason',
      field: 'rejectReason',
      filter: 'agTextColumnFilter',
      sortable: true
    }

  ];
  domLayout;
  // Pagination
  // Pagination Variables
  itemsPerPage = 10;
  totalItems = 0;
  currentPage = 1;
  pageReset = false;
  previousPage = 0;
  customerPage: any = null;
  pageMap: Map<number, any> = new Map<number, any>();
  showingStart: number;
  showingEnd: number;

  constructor(private customerRegistrationService: CustomerRegistrationService,
              private fb: UntypedFormBuilder, private alertService: AlertService,
              private loadingService: LoadingService, private cdref: ChangeDetectorRef,
              private userService: UserService, private router: Router) {
    this.customerApprovalForm = this.fb.group({
      registrationType: [null, [Validators.required]],
      status: [null, [Validators.required]]
    });

    // Get the current user.
    this.currentUser = this.userService.getUserDetails().subscribe(user => {
      this.currentUser = user;
      console.log('User: ', user);
      if (user && user.roles) {
        for (const role of user.roles) {
          if (role.id === 7) {
            this.registrationTypes = this.registrationTypesAll;
            break;
          } else {
            this.registrationTypes = this.registrationTypesUser;
          }
        }
        this.customerRegistrationService.customerApprovalFormState.pipe(first()).subscribe(state => state ?
          this.customerApprovalForm.patchValue(state) : null);
      }
    });
  }

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }

  ngOnInit() {
    this.domLayout = 'autoHeight';
    this.customerApprovalForm.get('status').disable();
    this.customerApprovalForm.get('registrationType').valueChanges.subscribe(registrationType => {
      if (registrationType) {
        this.customerApprovalForm.get('status').enable({onlySelf: true, emitEvent: false});
      } else {
        this.customerApprovalForm.get('status').disable({onlySelf: true, emitEvent: false});
      }
      this.getCustomerRegistration();
    });
    this.customerApprovalForm.get('status').valueChanges.subscribe(status => {
      this.getCustomerRegistration();
    });
  }

  getCustomerRegistration() {
    const status: any = (this.customerApprovalForm.get('status')?.value) ? (this.customerApprovalForm.get('status').value) : null;
    const registrationType: any = (this.customerApprovalForm.get('registrationType')?.value == "Authorized Official") ? "Reporting Official" : this.customerApprovalForm.get('registrationType').value ;
    if (AppConstants.isNotNullCondition(status) && AppConstants.isNotNullCondition(registrationType)) {
      console.log('Should get here once we change either dropdownlist');
      this.customerRegistrationService.customerApprovalFormState.next({
        'registrationType': registrationType,
        'status': status
      });
      this.customers = [];
      this.loadingService.show();
      this.customerRegistrationService.getCustomers(registrationType, status, this.currentUser.id).subscribe(customers => {
        this.customers = customers;
      }, (error) => {
        console.log('There was an error retrieving customers');
        this.loadingService.hide();
        this.alertService.error('There was an error retrieving customers');
        this.setupPagination();
        console.log(this.customers);
      }, () => {
        this.loadingService.hide();
        this.alertService.success('Successfully Found ' + this.customers.length + ' Customer(s)');
        this.setupPagination();
      });
    } else {
      // one of the dropdownlist doesnt have value yet.
    }
  }

  // Set Up Pagination Map. Create a Map with key representing page number and value as a list of object.
  setupPagination() {
    this.pageMap = new Map<number, any>();
    this.totalItems = this.customers.length;
    let pageCount = 1;
    for (let i = 0; i < this.totalItems; i = i + this.itemsPerPage) {
      const pageOfCustomers = this.customers.slice(i, i + this.itemsPerPage);
      this.pageMap.set(pageCount, pageOfCustomers);
      pageCount++;
    }
    // Reset the current page to the first page
    this.currentPage = 1;
    this.customerPage = this.pageMap.get(this.currentPage);
    this.showingStart = 1;

    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
  }

  // page event emitted from pagination component. Set the Current page as long as there is data to be displayed
  page(currentPage) {
    this.currentPage = currentPage;
    if (this.customerPage != null && this.customerPage.length !== 0) {
      this.customerPage = this.pageMap.get(currentPage);
    }

    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
    this.showingStart = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1;
  }

  // set the value of items per page when change from pagination component
  // this value is used for mapping in setupPagination() function
  itemsPerPageChanged(itemsPerPage) {
    console.log('Resetting Up Pagination!' + itemsPerPage);
    this.itemsPerPage = itemsPerPage;
    if (this.customerPage != null && this.customerPage.length !== 0) {
      this.setupPagination();
      this.pageReset = true;
    }
  }

  // when clicked on the link of reporting official
  onReportingOfficialClicked(cust) {
    if (cust.registrationStatus !== 'Confirm Pending') {
      this.router.navigate(['/customerapproval'],
        {queryParams: {userRegisterId: cust.userRegisterId}});
    }
  }

  // Export table to excel file amd download/save the file.
  exportData() {
    if (this.customers && this.customers.length > 0) {
      this.customerRegistrationService.export(this.customers).subscribe(dfr => {
        const byteData: number[] = dfr.byteData;
        const fileName: string = dfr.fileName;
        const numRows: number = dfr.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        console.log('numRows:' + numRows);
        const blob = new Blob([bytes], {
          type: null
        });
        saveAs(blob, fileName);
        this.alertService.success('Customers Downloaded - ' + numRows + ' Records found');
      }, (error) => {
        this.alertService.error('Failed to Export Data');
      });
    } else {
      this.alertService.warn('No Data to Export');
    }
  }

  onSelectedStatus() {
    this.status = this.customerApprovalForm.get('status').value;
  }

  onGridReady(params: any) {
    if (AppConstants.isNotNullCondition(this.status)) {
      this.gridAPI = params.gridAPI;
      this.columnAPI = params.columnApi;
      (this.status === 'Rejected') ? this.columnAPI.setColumnVisible('RejReason', true) : this.columnAPI.setColumnVisible('RejReason', false);
    }
  }
}
